
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandPartial as ObiCommandPartialElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-partial.js';
 
 
 

 
 export const ObiCommandPartial = createComponent({
   react: React,
   tagName: 'obi-command-partial',
   elementClass: ObiCommandPartialElement,
   events: {
     
   }
  });
 
 